<template>
  <div class="w-full flex items-center justify-center">
    <div class="flex h-full">
      <!--<span class="text-lg font-bold text-center text-orange-300 m-2">X</span>-->
      <value-or-variable-with-label label='X' v-model='value.x' type="number" :variables='[]'>
        <template #default="{}">
          <numberer v-model='value.x' @change="onChangeX" />
        </template>
      </value-or-variable-with-label>
    </div>

    <button class="mx-1 p-0 bg-black text-xs text-white hover:text-gray-700 hover:bg-gray-400 w-10 rounded-r cursor-pointer" @click='linked = !linked'>
      <link-variant  v-if='linked' />
      <link-variant-off  v-else />
    </button>

    <div class="flex h-full">
      <!--<span class="text-lg font-bold text-center text-orange-300 m-2">Y</span>-->
      <value-or-variable-with-label v-model='value.y' label='Y' type="number" :variables='[]'>
        <template #default="{}">
          <numberer v-model='value.y' @change="onChangeY" />
        </template>
      </value-or-variable-with-label>
    </div>
  </div>
</template>
<script>
import { cloneDeep, clone } from 'lodash';
import LinkVariant from '@icons/LinkVariant.vue';
import LinkVariantOff from '@icons/LinkVariantOff.vue';
import Numberer from '@ui/atoms/Numberer.vue';
import ValueOrVariableWithLabel from '@ui/molecules/ValueOrVariableWithLabel.vue';

export default {
  props:{
    value:{
      type:Object,
      required:true
    }
  },
  methods: {
    onInput(nv, ov) {
      this.ratio = this.value.y / this.value.x;
      console.log('emit change');
      this.$emit("change", nv, ov);
    },
    onChangeX(nv, ov) {
      let oldValue = cloneDeep(this.value);
      oldValue.x = ov;

      if (this.linked) {
        this.value.y = nv * this.ratio;
        if (isNaN(this.value.y)) {
          this.value.y = 1;
        }
      }

      this.onInput(clone(this.value), oldValue);
    },
    onChangeY(nv, ov) {
      let oldValue = cloneDeep(this.value);
      oldValue.y = ov;

      if (this.linked) {
        this.value.x = nv / this.ratio;
        if (isNaN(this.value.x)) {
          this.value.x = 1;
        }
      }
      this.onInput(clone(this.value), oldValue);
    }
  },
  data() {
    return {
      linked:true,
      ratio:this.value.y / this.value.x
    }
  },
  components:{
    Numberer,
    LinkVariant,
    LinkVariantOff,
    ValueOrVariableWithLabel
  }
}
</script>
